// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_CreateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_categorias/create
 *
 * Creates a new expense category.
 */
import { registerContract } from './validate'

export interface DespesasCategorias_CreateInput {
despesa_categoria_titulo: string
despesa_categoria_status?: number
despesa_categoria_investimento?: number
despesa_categoria_percentual_padrao?: number
despesa_categoria_descricao?: string
despesa_categoria_exige_nf?: number
despesa_categoria_grupo_pex?: string
despesa_categoria_natureza?: string
despesa_categoria_subcategoria?: string
}

registerContract('DespesasCategorias_CreateInput', {
  despesa_categoria_titulo:            { type: 'string',  required: true },
  despesa_categoria_status:            { type: 'number',  required: false },
  despesa_categoria_investimento:      { type: 'number',  required: false },
  despesa_categoria_percentual_padrao: { type: 'number',  required: false },
  despesa_categoria_descricao:         { type: 'string',  required: false },
  despesa_categoria_exige_nf:          { type: 'number',  required: false },
  despesa_categoria_grupo_pex:         { type: 'string',  required: false },
  despesa_categoria_natureza:          { type: 'string',  required: false },
  despesa_categoria_subcategoria:      { type: 'string',  required: false },
})
